<template>
  <div class="view-wrapper">
    <div class="botoes-topo-container elevation-2">
      <v-btn class="botao-pesquisa-triplo" dark color="primary" @click="acaoPreCadastro">
        <v-icon left>mdi-plus</v-icon>
        Novo Pré-Cadastro
      </v-btn>
    </div>

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="aoMudarTipoBusca"
      >
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
        <v-radio label="Razão" value="razao" color="primary"></v-radio>
        <v-radio label="Fantasia" value="fantasia" color="primary"></v-radio>
        <v-radio label="CNPJ/CPF" value="cnpj" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
          @keyup.enter="forcarBusca('qualquer')"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <v-card class="d-flex flex-column fill-height">
        
        <div v-if="loadingInicial" class="text-center pa-8 flex-grow-1">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-4 mb-0">Carregando pré-cadastros...</p>
        </div>

        <div v-else-if="!loadingInicial && resultados.length === 0" class="text-center pa-8 flex-grow-1">
          <v-icon size="48" color="grey lighten-1" class="mb-3">mdi-account-search-outline</v-icon>
          <p class="mb-2 text-subtitle-1 grey--text text--darken-2">Nenhum pré-cadastro encontrado.</p>
          <v-btn color="primary" outlined small @click="acaoPreCadastro">
            <v-icon left small>mdi-plus</v-icon> Adicionar Pré-Cadastro
          </v-btn>
        </div>

        <RecycleScroller
          v-else
          ref="scrollerComponent"  class="scroller"
          :items="resultados"
          :item-size="190" 
          key-field="id"
          v-slot="{ item }"
        >
          <div class="list-item-wrapper" style="height: 190px; border-bottom: 1px solid #e0e0e0;">
            <v-list-item
              class="list resultado-item-clicavel px-2 fill-height"
              :class="{ 'item-selecionado': item.enviar == 1 }"
              @click="selecionarItem(item)"
            >
              
              <v-list-item-content class="pl-4">
                <v-list-item-title :class="itemCor(item)" class="font-weight-medium text-wrap text-justify d-flex align-center justify-space-between" 
                  style="height: auto; line-height: 1.5rem; word-break: break-word;">
                  <span>{{ item.id }} - {{ item.cllnome }}</span>
                  <v-chip
                    v-if="item.atendido == 1"
                    x-small
                    color="success"
                    outlined
                    class="ml-2 font-weight-bold"
                  >
                    <v-icon x-small left>mdi-check-circle</v-icon>
                    Transmitido
                  </v-chip>
                </v-list-item-title>

                <v-list-item-subtitle v-if="item.cllnomefantasia">
                  {{ item.cllnomefantasia }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.cllendereco || item.cllbairro">
                  {{ item.cllendereco || '' }}
                  <span v-if="item.cllendereco && item.cllbairro"> - </span>
                  {{ item.cllbairro || '' }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.cllcidade || item.clluf">
                  {{ item.cllcidade || '' }}
                  <span v-if="item.cllcidade && item.clluf"> - </span>
                  {{ item.clluf || '' }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.cllcnpjCpf || item.cllrgInscricao">
                  <span v-if="item.cllcnpjCpf">
                      {{ formatarCpfCnpj(item.cllcnpjCpf) }}
                  </span>
                  <span v-if="item.cllrgInscricao && item.cllrgInscricao !== 'ISENTO'">
                      <span v-if="item.cllcnpjCpf"> - </span> {{ item.clltipopessoa === 'J' ? 'IE' : 'RG' }}: {{ item.cllrgInscricao }}
                  </span>
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.clltelefone || item.cllcelular">
                  Fone: {{ item.clltelefone || item.cllcelular }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.clldatadigitacao">
                  <span>Digitado em: {{ FormataDataGeral(item.clldatadigitacao) }}</span>
                </v-list-item-subtitle>

              </v-list-item-content>

              <v-list-item-action class="align-self-center">
                <v-btn 
                  icon 
                  @click.stop="abrirPrecadastro(item)" 
                  :title="item.atendido == 1 ? 'Transmitido (somente leitura / não permite edição)' : 'Editar Pré-Cadastro'"
                >
                  <v-icon :color="item.atendido == 1 ? 'grey darken-1' : 'primary'">
                    {{ item.atendido == 1 ? '' : 'mdi-pencil' }}
                  </v-icon>
                </v-btn>
              </v-list-item-action>

            </v-list-item>
          </div>
        </RecycleScroller>
      </v-card>
    </div>

    <!-- SNACKBAR DE AVISOS -->
    <!-- <v-snackbar
      v-model="snackbar"
      :color="snackbarCor"
      :timeout="3500"
      top
    >
      <v-icon left color="white" v-if="snackbarCor === 'warning'">mdi-alert-circle</v-icon>
      <v-icon left color="white" v-else-if="snackbarCor === 'success'">mdi-check-circle</v-icon>
      <v-icon left color="white" v-else>mdi-information</v-icon>
      {{ snackbarMensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar> -->

  </div>
</template>

<script>
import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import db from '@/plugins/dexie';
import moment from 'moment';

Vue.use(VueVirtualScroller);

export default {
  name: 'ViewListaPrecadastroCliente',

  data() {
    return {
      loadingInicial: true,
      itemSelecionado: null,
      resultados: [],
      todosLeads: [],
      idVendedorLogado: null,
      isOrigemPedido: this.$route.query.origem === 'pedido',
      
      termoBusca: this.$route.query.busca || '', 
      tipoBusca: this.$route.query.tipoBusca || 'razao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer',

      snackbar: false,
      snackbarMensagem: '',
      snackbarCor: 'info',
    };
  },

  computed: {
    labelBusca() {
      switch (this.tipoBusca) {
        case 'codigo': return 'Buscar por Código';
        case 'cnpj': return 'Buscar por CNPJ ou CPF';
        case 'fantasia': return 'Buscar por Nome Fantasia';
        case 'razao':
        default: return 'Buscar por Razão';
      }
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(newQuery) {
        this.isOrigemPedido = newQuery.origem === 'pedido';
        this.termoBusca = newQuery.busca || '';
        this.tipoBusca = newQuery.tipoBusca || 'razao';
        this.modoBusca = newQuery.modoBusca || 'qualquer';
        this.carregarLeads();
      },
    }
  },

  methods: {
    getTabelaLeads() {
      return db.clienteleads || db.clientelead || db.clienteprecadastro;
    },

    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

    aoMudarTipoBusca() {
      this.focarInputBusca();
      this.aplicarFiltro();
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return String(texto).normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
    },

    forcarBusca(modo) {
      const query = { ...this.$route.query };
      query.modoBusca = modo;
      query.busca = this.termoBusca ? this.termoBusca.trim() : '';
      query.tipoBusca = this.tipoBusca;

      this.$router.replace({ query }).catch(() => {});
    },

    async obterVendedorLogado() {
      try {
        const param = await db.parametro.toCollection().first();
        if (param) {
          this.idVendedorLogado = param.idvendedorlogado;
        }
      } catch (e) {
        console.error("Erro ao recuperar idvendedorlogado", e);
      }
    },

    async carregarLeads() {
      this.loadingInicial = true;
      await this.obterVendedorLogado();

      try {
        const tabelaLeads = this.getTabelaLeads();
        if (!tabelaLeads) {
          this.resultados = [];
          this.todosLeads = [];
          return;
        }

        let leads = await tabelaLeads.toArray();

        // Não exibir pré-cadastros que já foram atendidos
        leads = leads.filter(l => l.atendido != 1);

        // Se houver vendedor logado, pode filtrar caso idvendedor esteja presente
        if (this.idVendedorLogado) {
          leads = leads.filter(l => !l.cllidvendedor || l.cllidvendedor === this.idVendedorLogado);
        }

        this.todosLeads = leads;
        this.aplicarFiltro();
      } catch (error) {
        console.error("Erro ao carregar pré-cadastros:", error);
        this.resultados = [];
      } finally {
        this.loadingInicial = false;
      }
    },

    aplicarFiltro() {
      const termo = (this.termoBusca || '').trim();
      const termoNormalizado = this.removerAcentos(termo);
      const modo = this.modoBusca || 'qualquer';
      const tipo = this.tipoBusca || 'razao';

      let filtrados = [...this.todosLeads];

      if (termo) {
        filtrados = filtrados.filter(item => {
          if (tipo === 'codigo') {
            const cod = (item.id || item.cllidclienteprecadastro || '').toString();
            return modo === 'inicio' ? cod.startsWith(termo) : cod.includes(termo);
          }
          if (tipo === 'fantasia') {
            const fant = this.removerAcentos(item.cllnomefantasia || '');
            return modo === 'inicio' ? fant.startsWith(termoNormalizado) : fant.includes(termoNormalizado);
          }
          if (tipo === 'cnpj') {
            const termoCnpjLimpo = termo.replace(/\D/g, '');
            const doc = (item.cllcnpjCpf || '').replace(/\D/g, '');
            return modo === 'inicio' ? doc.startsWith(termoCnpjLimpo) : doc.includes(termoCnpjLimpo);
          }
          // Default: razao / nome
          const nome = this.removerAcentos(item.cllnome || '');
          return modo === 'inicio' ? nome.startsWith(termoNormalizado) : nome.includes(termoNormalizado);
        });
      }

      // Ordenação padrão
      filtrados.sort((a, b) => {
        if (tipo === 'codigo') {
          return (a.id || 0) - (b.id || 0);
        }
        if (tipo === 'fantasia') {
          return (a.cllnomefantasia || '').localeCompare(b.cllnomefantasia || '', 'pt-BR', { sensitivity: 'base' });
        }
        return (a.cllnome || '').localeCompare(b.cllnome || '', 'pt-BR', { sensitivity: 'base' });
      });

      this.resultados = filtrados;
    },

    selecionarItem(item) {
      if (!item) return;

      if (this.isOrigemPedido) {
        sessionStorage.setItem('pesquisaResultado', JSON.stringify({
          tipo: 'Precadastro',
          codigo: item.id,
          descricao: item.cllnome,
          isPrecadastro: true,
          lead: item,
        }));
        this.$router.push('/cadastro-pedido');
      } else {
        if (item.atendido == 1) {
          this.snackbarMensagem = 'Este pré-cadastro já foi transmitido ao servidor e não pode ser alterado.';
          this.snackbarCor = 'primary';
          this.snackbar = true;
          return;
        }
        this.abrirPrecadastro(item);
      }
    },

    async toggleEnviar(item, valor) {
      if (!item || !item.id) return;

      const novoValor = (valor !== undefined && valor !== null) ? (valor ? 1 : 0) : (item.enviar == 1 ? 0 : 1);
      this.$set(item, 'enviar', novoValor);

      const leadOriginal = this.todosLeads.find(l => l.id === item.id);
      if (leadOriginal) {
        this.$set(leadOriginal, 'enviar', novoValor);
      }

      try {
        const tabelaLeads = this.getTabelaLeads();
        if (tabelaLeads) {
          await tabelaLeads.update(item.id, { enviar: novoValor });
        }
      } catch (error) {
        console.error("Erro ao atualizar campo enviar do pré-cadastro:", error);
      }
    },

    toggleSelecao(item) {
      this.toggleEnviar(item);
    },

    itemCor() {
      return '';
    },

    FormataDataGeral(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY HH:mm');
    },

    formatarCpfCnpj(valor) {
      if (!valor) return '';
      const digitos = valor.replace(/\D/g, '');
      if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      return valor;
    },

    acaoPreCadastro() {
      const query = {};
      if (this.isOrigemPedido) {
        query.origem = 'pedido';
      }
      this.$router.push({ path: '/precadastro', query });
    },

    abrirPrecadastro(item) {
      if (!item || !item.id) return;
      if (item.atendido == 1 && !this.isOrigemPedido) {
        this.snackbarMensagem = 'Este pré-cadastro já foi transmitido ao servidor e não pode ser alterado.';
        this.snackbarCor = 'primary';
        this.snackbar = true;
        return;
      }
      const query = { id: item.id };
      if (this.isOrigemPedido) {
        query.origem = 'pedido';
      }
      this.$router.push({
        path: '/precadastro',
        query,
      });
    },
  },
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
}
.botoes-topo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  background-color: #f5f5f5;
  flex-shrink: 0;
}
.botao-pesquisa-triplo {
  width: 100%;
  max-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-selecionado {
  background-color: #E3F2FD !important;
}

.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 10px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}
.list {
  background-color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
::v-deep .v-input--radio-group__input {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 0px !important;
}
</style>